import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_women_socks: FaireCategoryEntity = {
  token: "cat_women-socks",
  type: "category",
  name: "Socks & hosiery",
  level: 3,
  parentToken: "cat_apparel-women",
  href: "/category/women/socks-hosiery",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
